type NodeServiceTokenBridge = {
  nodeServiceAuthToken?: string;
  getNodeServiceAuthToken?: () => string | Promise<string>;
};

/** Resolves the rotating local node-service credential for each connection. */
export class NodeServiceCredentialService {
  public constructor(private readonly port: number) {}

  public async resolve(): Promise<string | null> {
    if (typeof window === 'undefined') return null;

    const bridge = (window as unknown as { playcast?: NodeServiceTokenBridge }).playcast;
    if (!bridge) return null;

    try {
      if (typeof bridge.getNodeServiceAuthToken === 'function') {
        const token = await bridge.getNodeServiceAuthToken();
        if (typeof token === 'string' && token.length > 0) return token;
      }
      if (typeof bridge.nodeServiceAuthToken === 'string' && bridge.nodeServiceAuthToken.length > 0) {
        return bridge.nodeServiceAuthToken;
      }
    } catch (error) {
      console.error('[Node Service Client] Failed to read node-service auth token:', error);
    }

    return null;
  }

  public buildConnectionUrl(token: string | null): string {
    const base = `ws://localhost:${this.port}/`;
    return token ? `${base}?token=${encodeURIComponent(token)}` : base;
  }
}
